import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClientoverview = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 10,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#FFF",
		children: [/* @__PURE__ */ _jsx("path", { d: "M15.934 4.768C15.812 4.573 12.917 0 8 0 3.08 0 .185 4.573.063 4.768a.441.441 0 0 0 0 .455C.185 5.427 3.08 10 8 10c4.918 0 7.813-4.573 7.935-4.768a.441.441 0 0 0 0-.464zM8 9.091C4.233 9.09 1.673 5.909 1.033 5c.64-.91 3.2-4.09 6.966-4.09 3.765 0 6.325 3.18 6.966 4.09-.64.91-3.177 4.09-6.966 4.09z" }), /* @__PURE__ */ _jsx("path", { d: "M8 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" })]
	})
});
export default SvgClientoverview;
